import * as API from "../data/report_api";
import {signOutAction} from "./auth_actions";

export const GET_CREATE_REPORT_DETAILS = "get_report_details_for_creation";
export const ADD_NEW_ROOM_AT_LAST = "add_new_room_at_last";
export const ADD_NEW_GROUP_AT_LAST = "add_new_group_at_last";
export const ADD_NEW_ITEM_AT_LAST = "add_new_item_at_last";

export const REMOVE_IMAGE_FROM_ITEM = "remove_image_from_item";
export const ADD_MEDIA_TO_REPORT_OFFLINE = "add_image_into_queue_for_upload";
export const REMOVE_MEDIA_FROM_REPORT_OFFLINE = "remove_image_from_queue_of_uploads";
export const CLEAR_DATA = "clear_old_data";

export const REMOVE_ROOM_FROM_REPORT = "remove_room_from_report";
export const REMOVE_GROUP_FROM_REPORT = "remove_group_from_report";
export const REMOVE_ITEM_FROM_REPORT = "remove_item_from_report";

export const UPDATE_ROOM_IN_REPORT = "update_room_in_report";
export const UPDATE_GROUP_IN_REPORT = "update_group_in_report";
export const UPDATE_ITEM_IN_REPORT = "update_item_in_report";

export const RESET_REPORT_UPDATE_DATA = "report_update_data_reset";
export const UPDATE_REPORT_AS_IMAGE_DELETED = "report_image_deleted";

export const ADD_NEW_KEY_INTO_REPORT = "add_new_key_into_report";
export const UPDATE_KEY_IN_REPORT = "update_key_in_report";
export const DELETE_KEY_IN_REPORT = "delete_key_in_report";
export const RESET_CUSTOM_OBJECT_FROM_REPORT_UPDATE = "reset_report_update_additional_data";
export const ADD_KEY_IMAGE = "add_new_key_image_into_report";

export const ADD_NEW_ALARM_INTO_REPORT = "add_new_alarm_into_report";
export const UPDATE_ALARM_IN_REPORT = "update_alarm_in_report";
export const DELETE_ALARM_IN_REPORT = "delete_alarm_in_report";

export const ADD_NEW_RECEIPT_INTO_REPORT = "add_new_receipt_into_report";
export const UPDATE_RECEIPT_IN_REPORT = "update_receipt_in_report";
export const DELETE_RECEIPT_IN_REPORT = "delete_receipt_in_report";

export const ADD_NEW_DISCLAIMER_INTO_REPORT = "add_new_disclaimer_into_report";
export const UPDATE_DISCLAIMER_IN_REPORT = "update_disclaimer_in_report";
export const DELETE_DISCLAIMER_IN_REPORT = "delete_disclaimer_in_report";
export const ADD_MEDIA_TO_DISCLAIMER_OFFLINE = "add_disclaimer_image_into_queue_for_upload";
export const REMOVE_MEDIA_FROM_DISCLAIMER_OFFLINE = "remove_disclaimer_image_from_queue_of_uploads";

export const ADD_NEW_METER_INTO_REPORT = "add_new_meter_into_report";
export const UPDATE_METER_IN_REPORT = "update_meter_in_report";
export const DELETE_METER_IN_REPORT = "delete_meter_in_report";
export const DELETE_READING_IN_METER = "delete_reading_in_meter";
export const ADD_NEW_READING_IN_METER = "add_new_reading_in_meter";
export const UPDATE_READING_IN_METER = "update_reading_in_meter";
export const UPDATE_METER_ABSENCE_IN_REPORT = "update_meter_absence"

export const UPDATE_ADDITIONAL_SUMMARY_IN_REPORT = "update_additional_summary_in_report";

export const LOAD_ROOM_TEMPLATE = "load_room_template";
export const LOAD_AI_DATA = "load_ai_data";
export const LOAD_SAVE_STATE = "load_save_state";

export const LOG_ERROR_RESPONSE = "log_error_response"

export const SET_SELECTED_OVERLAY_IMAGE = "set_selected_overlay_image"
export const UPDATE_OVERLAY_IMAGE_LIST = "update_overlay_image_list"

export function getReportById(URL, reportId,successCallback) {
    return async (dispatch) => {
        dispatch({type: CLEAR_DATA});
        const response = await API.getReportById(URL, reportId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            if(response.status === 403){
                successCallback(response.status);
            }
            else {
                dispatch({
                    type: GET_CREATE_REPORT_DETAILS,
                    payload: response
                });
            }
        }
    };
}

export function addNewRoomAtLast(newRoomObject) {
    return async (dispatch) => {
        dispatch({
            type: ADD_NEW_ROOM_AT_LAST,
            roomObject: newRoomObject
        });
    };
}

export function addNewGroupAtLast(roomIndex, groupObj) {
    return async (dispatch) => {
        dispatch({
            type: ADD_NEW_GROUP_AT_LAST,
            roomIndex: roomIndex,
            groupObject: groupObj
        });
    };
}

export function addNewItemAtLast(roomIndex, groupIndex, itemObj) {
    return async (dispatch) => {
        dispatch({
            type: ADD_NEW_ITEM_AT_LAST,
            roomIndex: roomIndex,
            groupIndex: groupIndex,
            itemObject: itemObj
        });
    };
}

export function addNewMediaIntoReport(roomIndex, groupIndex, itemIndex, fileObj) {
    return async (dispatch) => {
        dispatch({type: ADD_MEDIA_TO_REPORT_OFFLINE, roomIndex: roomIndex, groupIndex:groupIndex,itemIndex: itemIndex, media: fileObj});
    }
}

export function removeMediaFromReport(roomIndex,groupIndex,itemIndex,fileObj,eType) {
    return async (dispatch) => {
        dispatch({type: UPDATE_REPORT_AS_IMAGE_DELETED, roomIndex: roomIndex, groupIndex:groupIndex,itemIndex: itemIndex, media: fileObj,eType:eType});
    }
}

export function deleteRoomFromReport(roomIndex) {
    return async (dispatch) => {
        dispatch({type:REMOVE_ROOM_FROM_REPORT,roomIndex:roomIndex});
    }
}

export function deleteGroupFromReport(roomIndex,groupIndex,roomId) {
    return async (dispatch) => {
        dispatch({type:REMOVE_GROUP_FROM_REPORT,roomIndex:roomIndex,groupIndex:groupIndex,roomId:roomId});
    }
}

export function deleteItemFromReport(roomIndex,groupIndex,itemIndex) {
    return async (dispatch) => {
        dispatch({type:REMOVE_ITEM_FROM_REPORT,roomIndex:roomIndex,groupIndex:groupIndex,itemIndex:itemIndex});
    }
}


export function updateRoomInReport(roomIndex,roomObj) {
    return async (dispatch) => {
        dispatch({type:UPDATE_ROOM_IN_REPORT,roomIndex:roomIndex,roomObject:roomObj});
    }
}

export function updateGroupInReport(roomIndex,groupIndex,groupObj) {
    return async (dispatch) => {
        dispatch({type:UPDATE_GROUP_IN_REPORT,roomIndex:roomIndex,groupIndex:groupIndex,groupObject:groupObj});
    }
}

export function updateItemInReport(roomIndex,groupIndex,itemIndex,itemObj) {
    return async (dispatch) => {
        dispatch({type:UPDATE_ITEM_IN_REPORT,roomIndex:roomIndex,groupIndex:groupIndex,itemIndex:itemIndex,itemObject:itemObj});
    }
}
export function resetReportUpdateObject(removeImages) {
    return async (dispatch) => {
        dispatch({type:RESET_REPORT_UPDATE_DATA,removeImages:removeImages});
    }

}

export function uploadImages(image,successCallBack) {
    return async (dispatch) => {
        const response = await API.addImageForReport(image);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            if(successCallBack){
                successCallBack(response,image);
            }
        }
    }
}

export function recordImageDeletedAsUpdate(roomIndex,groupIndex,itemIndex,imageObj) {
    return async (dispatch) => {
        dispatch({type:REMOVE_MEDIA_FROM_REPORT_OFFLINE,roomIndex:roomIndex,groupIndex:groupIndex,itemIndex:itemIndex,imageObj:imageObj});
    }
}

export function addNewKeyIntoReport(keysObject) {
    return async (dispatch) => {
        dispatch({type:ADD_NEW_KEY_INTO_REPORT,keysObject:keysObject});
    }
}

export function updateKeyInReport(keysObject) {
    return async (dispatch) => {
        dispatch({type:UPDATE_KEY_IN_REPORT,keysObject:keysObject});
    }
}

export function deleteKeyInReport(keysObject) {
    return async (dispatch) => {
        dispatch({type:DELETE_KEY_IN_REPORT,keysObject:keysObject});
    }
}

export function resetDataQueuedInAPI(objectToReset) {
    return async (dispatch) => {
        dispatch({type:RESET_CUSTOM_OBJECT_FROM_REPORT_UPDATE,objectToReset:objectToReset});
    }
}
export function setKeyImage(inspectionType,imageId,dataURL){
    return async (dispatch) => {
        dispatch({type:ADD_KEY_IMAGE,inspectionType:inspectionType,imageId:imageId,dataURL:dataURL});
    }
}

export function addNewAlarm(alarmObject){
    return async(dispatch) => {
        dispatch({type:ADD_NEW_ALARM_INTO_REPORT,alarmObject:alarmObject});
    }
}

export function updateAlarmInReport(alarmObject){
    return async(dispatch) => {
        dispatch({type:UPDATE_ALARM_IN_REPORT,alarmObject:alarmObject});
    }
}

export function deleteAlarmInReport(alarmObject) {
    return async(dispatch) => {
        dispatch({type:DELETE_ALARM_IN_REPORT,alarmObject:alarmObject});
    }
}

export function addNewReceipt(receiptObject){
    return async(dispatch) => {
        dispatch({type:ADD_NEW_RECEIPT_INTO_REPORT,receiptObject:receiptObject});
    }
}

export function updateReceiptInReport(receiptObject){
    return async(dispatch) => {
        dispatch({type:UPDATE_RECEIPT_IN_REPORT,receiptObject:receiptObject});
    }
}

export function deleteReceiptInReport(receiptObject) {
    return async(dispatch) => {
        dispatch({type:DELETE_RECEIPT_IN_REPORT,receiptObject:receiptObject});
    }
}

export function addNewMeter(metersObject){
    return async(dispatch) => {
        dispatch({type:ADD_NEW_METER_INTO_REPORT,metersObject:metersObject});
    }
}

export function updateMeterInReport(metersObject){
    return async(dispatch) => {
        dispatch({type:UPDATE_METER_IN_REPORT,metersObject:metersObject});
    }
}

export function updateMeterAbsenceInfo(absenceInfo){
    return async(dispatch) => {
        dispatch({type:UPDATE_METER_ABSENCE_IN_REPORT,absenceInfo:absenceInfo});
    }
}

export function deleteMeterInReport(metersObject) {
    return async(dispatch) => {
        dispatch({type:DELETE_METER_IN_REPORT,metersObject:metersObject});
    }
}

export function handleReadingDeleteInMeter(meterIndex,readingIndex,readingObject) {
    return async(dispatch) => {
        dispatch({type:DELETE_READING_IN_METER,meterIndex:meterIndex,readingIndex:readingIndex,readingObject:readingObject});
    }
}

export function handleReadingUpdate(meterIndex,readingIndex,readingObject) {
    return async(dispatch) => {
        dispatch({type:UPDATE_READING_IN_METER,meterIndex:meterIndex,readingIndex:readingIndex,readingObject:readingObject});
    }
}

export function addNewReadingToMeter(readingObject,meterIndex) {
    return async (dispatch) => {
        dispatch({type:ADD_NEW_READING_IN_METER,readingObject:readingObject,meterIndex:meterIndex})
    }
}

export function loadNewRoomTemplate(templateObject) {
    return async(dispatch) => {
        dispatch({type:LOAD_ROOM_TEMPLATE,templateObject:templateObject})
    }
}

export function loadSaveState(parsedRooms) {
    return async(dispatch) => {
        dispatch({type:LOAD_SAVE_STATE,parsedRooms:parsedRooms})
    }
}

export function loadAIData(parsedRooms,other_template = false) {
    return async(dispatch) => {
        dispatch({type:LOAD_AI_DATA,parsedRooms:parsedRooms, other_template:other_template})
    }
}

export function addNewDisclaimer(disclaimerObject){
    return async(dispatch) => {
        dispatch({type:ADD_NEW_DISCLAIMER_INTO_REPORT,disclaimerObject:disclaimerObject});
    }
}

export function updateDisclaimerInReport(disclaimerObject){
    return async(dispatch) => {
        dispatch({type:UPDATE_DISCLAIMER_IN_REPORT,disclaimerObject:disclaimerObject});
    }
}

export function deleteDisclaimerInReport(disclaimerObject) {
    return async (dispatch) => {
        dispatch({type: DELETE_DISCLAIMER_IN_REPORT, disclaimerObject: disclaimerObject});
    }
}

export function addNewDisclaimerMedia(disclaimerIndex, fileObj) {
    return async (dispatch) => {
        dispatch({type: ADD_MEDIA_TO_DISCLAIMER_OFFLINE,disclaimerIndex:disclaimerIndex, media: fileObj});
    }
}

export function removeMediaFromDisclaimer(disclaimerIndex,disclaimerObj,fileObj) {
    return async (dispatch) => {
        dispatch({type: REMOVE_MEDIA_FROM_DISCLAIMER_OFFLINE, disclaimerIndex:disclaimerIndex, media: fileObj,disclaimerObj:disclaimerObj});
    }
}

export function updateAdditionalSummaryDetailsInReport(additionalSummaryNotesObject){
    return async(dispatch) => {
        dispatch({type:UPDATE_ADDITIONAL_SUMMARY_IN_REPORT,additionalSummaryNotesObject:additionalSummaryNotesObject});
    }
} 

export function logErrorResponse(errorResponse = undefined, roomErrorResponse = undefined){
    return async(dispatch) => {
        dispatch({type:LOG_ERROR_RESPONSE,errorResponse:errorResponse,roomErrorResponse:roomErrorResponse});
    }
} 

export function setSelectedOverlayImage(overlayImage = undefined, dontScrollToImg = false,lagMode = false){
    return async(dispatch) => {
        let jumpLoc = undefined
        if (overlayImage && !dontScrollToImg) {
            jumpLoc =  document.getElementById(`${overlayImage.id}`)
        }
        if(jumpLoc) {
            if(lagMode) {
                setTimeout(() => {
                jumpLoc.scrollIntoView({ behavior: "auto", inline: "center", block: "nearest" });
                }, 300);
            } else {
                jumpLoc.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
            }
                
        }
        dispatch({type:SET_SELECTED_OVERLAY_IMAGE,overlayImage:overlayImage});
    }
} 
export function updateOverlayImageList(overlayImageList = undefined){
    return async(dispatch) => {
        dispatch({type:UPDATE_OVERLAY_IMAGE_LIST,overlayImageList:overlayImageList});
    }
} 


// WEBPACK FOOTER //
// ./src/actions/report_action.js